import $ from "jquery";
import slickSlider from "../../common/slickSlider.js";

export default () => {
  document.querySelectorAll(".js-carousel__slider").forEach((el) => {
    const breakpoint = 679;
    const playSpeed = 5000;

    const initCallback = (event, slick) => {
      setTimeout(() => {
        
      }, playSpeed * slick.slideCount);
    };

    let sliderActive = document.documentElement.clientWidth > breakpoint;
    const customPaging = (slider, i) => {
      // leading zero for single digits, 01 - 99
      const number = `0${i + 1}`.slice(-2);

      return `<button type="button" class="carousel__dot link">${number}</button>`;
    };

    const conf = {
      autoplay: true,
      infinite: true,
      autoplaySpeed: playSpeed,
      customPaging,
      responsive: [
        {
          breakpoint: breakpoint,
        },
      ],
    };

    slickSlider(el, conf, initCallback);

    window.addEventListener("resize", () => {
      const documentWidth = document.documentElement.clientWidth;
      if (!sliderActive && documentWidth > breakpoint) {
        slickSlider(el, conf, initCallback);
      }
      if (sliderActive && documentWidth <= breakpoint) {
        // fix Slick Slider bug => https://github.com/kenwheeler/slick/issues/4083
        el.querySelectorAll("a").forEach((link) =>
          link.removeAttribute("tabindex"),
        );
      }
      sliderActive = document.documentElement.clientWidth > breakpoint;
    });

    $(".hero-carousel .pause").click(function(){
          $(el).slick('slickPause');
          $(this).hide();
          $(".hero-carousel .play").show();
    });

    $(".hero-carousel .play").click(function(){
          $(el).slick('slickPlay');
          $(this).hide();
          $(".hero-carousel .pause").show();
    });

    $(".video-play-btn").click(function(){
        var videoId = $(this).attr("data-video-url");
        var url = videoId + "?rel=0&autoplay=1";

        var modal = $("#video-modal");
        var iframe = $("#video-modal iframe");

        if (iframe){
          $(modal).show();
          $(iframe).attr("src", url);
        }

        $(".hero-carousel .pause").click();
    });

    $(".close-video").click(function(){
        var modal = $("#video-modal");
        var iframe = $("#video-modal iframe");

        if (iframe){
          $(modal).hide();
          $(iframe).attr("src", "");
        }

        $(".hero-carousel .play").click();
    });
  });
};
